import { render, staticRenderFns } from "./job-index.vue?vue&type=template&id=252cb30e&scoped=true"
import script from "./job-index.vue?vue&type=script&lang=js"
export * from "./job-index.vue?vue&type=script&lang=js"
import style0 from "./job-index.vue?vue&type=style&index=0&id=252cb30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252cb30e",
  null
  
)

export default component.exports